import styled from "styled-components";
import type { GlobalToken } from "antd";
import { radius } from "@libertify/ui";

export interface TokenProps {
  $token: GlobalToken;
}

export const Wrap = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 40px 0 40px 40px;

  @media (width <= 1000px) {
    padding: 24px 20px 40px;
  }
`;

export const StepEyebrow = styled.div<TokenProps>`
  font-size: ${({ $token }) => $token.fontSizeSM}px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ $token }) => $token.colorPrimary};
  margin-bottom: 8px;
`;

export const Title = styled.h2<TokenProps>`
  font-size: ${({ $token }) => $token.fontSizeHeading4}px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: ${({ $token }) => $token.colorText};
  margin: 0 0 24px;
`;

// Horizontal, scroll-snapping row of playbook cards. Scrollbar hidden — scroll
// with trackpad / shift-wheel; the row bleeds to the right edge of the page.
export const Slider = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: auto;
  padding-bottom: 8px;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Slide = styled.div`
  flex: 0 0 300px;
  max-width: 300px;
  height: min(440px, calc(100vh - 260px));
  scroll-snap-align: start;
`;

export const StateWrap = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding-right: 40px;
`;

// "Build your own" ghost card — trailing dashed card in the carousel.
export const GhostCard = styled.button<TokenProps>`
  flex: 0 0 300px;
  max-width: 300px;
  height: min(440px, calc(100vh - 260px));
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 32px;
  border-radius: ${radius.box}px;
  cursor: pointer;
  font-family: inherit;
  background: transparent;
  border: 2px dashed ${({ $token }) => $token.colorBorder};
  color: ${({ $token }) => $token.colorTextSecondary};
  transition: all ${({ $token }) => $token.motionDurationMid};

  &:hover {
    border-color: ${({ $token }) => $token.colorPrimary};
    color: ${({ $token }) => $token.colorPrimary};
    background: ${({ $token }) => $token.colorPrimaryBg};
  }

  &:focus-visible {
    outline: 2px solid ${({ $token }) => $token.colorPrimary};
    outline-offset: 2px;
  }
`;

export const GhostIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: ${radius.circle};
  border: 1.5px dashed currentColor;
`;

export const GhostTitle = styled.span<TokenProps>`
  font-size: ${({ $token }) => $token.fontSizeLG}px;
  font-weight: 600;
  color: ${({ $token }) => $token.colorText};
`;

export const GhostDesc = styled.span<TokenProps>`
  font-size: ${({ $token }) => $token.fontSize}px;
  color: ${({ $token }) => $token.colorTextTertiary};
  max-width: 220px;
  line-height: 1.4;
  text-align: center;
`;
